import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../redux/organizationUnits/selector";


const Header = () => {
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const { header, footer, visible, sidebar,theme,primary ,secondary} = result
	const [logo, setLogo] = useState<any>()
	const [isMenu, setIsMenu] = useState(false)
	const [activeIndex, setActiveIndex] = useState(null);
	const [activeSubIndex, setActiveSubIndex] = useState(null);
	const organizationLists= useSelector(selectListItems)
	const [menus, setMenus] = useState([
		{
        id: `main-menu-2-all`,
        path: '/management/platform-management/opennetwork-domains',
        label: 'DBN Management',
        isEnabled:true,
        svg:(
          <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12a9 9 0 0 1-9 9c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9zm-7-5v6l3 3v-6"></path>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'Global Registrations',
            path: '/management/organization/dbn/global-org-registrations',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path d="M18.7304 14.6701L14.5804 18.8201C14.4204 18.9801 14.2704 19.2901 14.2304 19.5101L14.0004 21.1001C13.9204 21.6701 14.3204 22.0801 14.8904 21.9901L16.4804 21.7601C16.7004 21.7301 17.0104 21.5701 17.1704 21.4101L21.3204 17.2601C22.0304 16.5501 22.3704 15.7101 21.3204 14.6601C20.2804 13.6201 19.4504 13.9501 18.7304 14.6701Z" fill="currentColor"></path>
              <path d="M18.1406 15.2603C18.4906 16.5203 19.4806 17.5002 20.7406 17.8602L18.1406 15.2603Z" fill="currentColor"></path>
              <path d="M2.02977 14.6299C2.02977 14.6599 2.00977 14.6999 2.00977 14.7299C2.92977 16.5699 4.42978 18.0799 6.26978 18.9899C6.29978 18.9899 6.33977 18.9699 6.36977 18.9699C6.02977 17.8099 5.76977 16.6199 5.57977 15.4299C4.37977 15.2299 3.18977 14.9699 2.02977 14.6299Z" fill="currentColor" opacity="0.4"></path>
              <path d="M19.0701 6.42993C18.1301 4.45993 16.5401 2.86994 14.5801 1.93994C14.9401 3.12994 15.2401 4.34995 15.4401 5.56995C16.6601 5.76995 17.8801 6.05993 19.0701 6.42993Z" fill="currentColor" opacity="0.4"></path>
              <path d="M1.92969 6.43002C3.12969 6.07002 4.3497 5.77004 5.5697 5.57004C5.7697 4.38004 6.0197 3.20004 6.3597 2.04004C6.3297 2.04004 6.28969 2.02002 6.25969 2.02002C4.37969 2.95002 2.84969 4.52002 1.92969 6.43002Z" fill="currentColor" opacity="0.4"></path>
              <path d="M13.8197 5.36023C13.5797 4.06023 13.2797 2.76024 12.8497 1.50024C12.8297 1.43024 12.8297 1.37025 12.8197 1.29025C12.0797 1.11025 11.2997 0.990234 10.4997 0.990234C9.68969 0.990234 8.91969 1.10025 8.16969 1.29025C8.15969 1.36025 8.16969 1.42024 8.14969 1.50024C7.72969 2.76024 7.41969 4.06023 7.17969 5.36023C9.38969 5.12023 11.6097 5.12023 13.8197 5.36023Z" fill="currentColor" opacity="0.4"></path>
              <path d="M5.36023 7.18018C4.05023 7.42018 2.76023 7.72018 1.50023 8.15018C1.43023 8.17018 1.37022 8.17018 1.29022 8.18018C1.11022 8.92018 0.990234 9.70018 0.990234 10.5002C0.990234 11.3102 1.10022 12.0802 1.29022 12.8302C1.36022 12.8402 1.42023 12.8302 1.50023 12.8502C2.76023 13.2702 4.05023 13.5802 5.36023 13.8202C5.12023 11.6102 5.12023 9.39018 5.36023 7.18018Z" fill="currentColor" opacity="0.4"></path>
              <path d="M19.7009 8.18018C19.6309 8.18018 19.5709 8.17018 19.4909 8.15018C18.2309 7.73018 16.9309 7.42018 15.6309 7.18018C15.8809 9.39018 15.8809 11.6102 15.6309 13.8102C16.9309 13.5702 18.2309 13.2702 19.4909 12.8402C19.5609 12.8202 19.6209 12.8302 19.7009 12.8202C19.8809 12.0702 20.0009 11.3002 20.0009 10.4902C20.0009 9.70017 19.8909 8.93018 19.7009 8.18018Z" fill="currentColor" opacity="0.4"></path>
              <path d="M7.17969 15.6401C7.41969 16.9501 7.71969 18.2401 8.14969 19.5001C8.16969 19.5701 8.15969 19.6301 8.16969 19.7101C8.91969 19.8901 9.68969 20.0101 10.4997 20.0101C11.2997 20.0101 12.0797 19.9001 12.8197 19.7101C12.8297 19.6401 12.8297 19.5801 12.8497 19.5001C13.2697 18.2401 13.5797 16.9501 13.8197 15.6401C12.7197 15.7601 11.6097 15.8501 10.4997 15.8501C9.38969 15.8401 8.27969 15.7601 7.17969 15.6401Z" fill="currentColor" opacity="0.4"></path>
              <path d="M6.94961 6.9501C6.64961 9.3101 6.64961 11.6901 6.94961 14.0601C9.30961 14.3601 11.6896 14.3601 14.0596 14.0601C14.3596 11.7001 14.3596 9.3201 14.0596 6.9501C11.6896 6.6501 9.30961 6.6501 6.94961 6.9501Z" fill="currentColor" opacity="0.4"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Domains',
            path: '/management/platform-management/opennetwork-domains',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Categories',
            path: '/management/platform-management/opennetwork-categories',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="28" width="36" height="14" rx="4" stroke="currentColor" stroke-width="4"></rect>
              <path d="M20 7H10C7.79086 7 6 8.79086 6 11V17C6 19.2091 7.79086 21 10 21H20" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path>
              <circle cx="34" cy="14" r="8" fill="currentColor" stroke="currentColor" stroke-width="4"></circle>
              <circle cx="34" cy="14" r="3" fill="currentColor"></circle>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Product Types',
            path: '/management/platform-management/opennetwork-product-types',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M10 4V2H2V10H4V6C4 4.89543 4.89543 4 6 4H10zM12 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V12H2C0.89543 12 0 11.1046 0 10V2C0 0.89543 0.89543 0 2 0H10C11.1046 0 12 0.89543 12 2V4zM6 6V14H14V6H6z"/>
            </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/platform-management/businesses',
        label: 'Business Management',
        isEnabled:true,
        svg:(
          <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <title></title>
    <g id="Card">
      <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
    </g>
  </g>
</svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'Business',
            path: '/management/platform-management/businesses',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path fill="currentColor" d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Tenants',
            path: '/management/platform-management/tenants',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.25 12.5C12.25 13.6046 11.3546 14.5 10.25 14.5C9.14543 14.5 8.25 13.6046 8.25 12.5C8.25 11.3954 9.14543 10.5 10.25 10.5C11.3546 10.5 12.25 11.3954 12.25 12.5Z M14.25 4.5L20 10.1893V18H16.5V20H4V11.9393L10.25 5.68933L11.625 7.06433L14.25 4.5Z M18.5 10.8107V16.5H16.5V11.9393L12.6857 8.12499L14.25 6.56065L18.5 10.8107Z M5.5 12.5607V18.5H6.78545C7.02806 16.8038 8.48677 15.5 10.25 15.5C12.0132 15.5 13.4719 16.8038 13.7146 18.5H15V12.5607L10.25 7.81065L5.5 12.5607Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Business Users',
            path: '/management/platform-management/business-users',
            isEnabled:true,
            svg:(
				<svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<path d="M13 20V18C13 15.2386 10.7614 13 8 13C5.23858 13 3 15.2386 3 18V20H13ZM13 20H21V19C21 16.0545 18.7614 14 16 14C14.5867 14 13.3103 14.6255 12.4009 15.6311M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9Z"/>
			  </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/platform-management/domains',
        label: 'Platform Management',
        isEnabled:true,
        svg:(
          <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <title></title>
            <g id="Card">
              <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
            </g>
          </g>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'Domains',
            path: '/management/platform-management/domains',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Networks',
            path: '/management/dbaas/networks',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-7 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14v4.833A1.166 1.166 0 0 1 10.833 20H4.167A1.167 1.167 0 0 1 3 18.833V7.167A1.166 1.166 0 0 1 4.167 6h6.666m0-2H3v15.768m7.889 2.121-7.778-7.778"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Applications',
            path: '/management/platform-management/applications',
            isEnabled:true,
            svg:(
              <svg className="h-7 w-6  mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 13H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2m-4 6h-4v-4h4v4zM10 4h4v4h-4V4zM20 4h-4v4h4V4zM20 10h-4v4h4v-4zM14 10h-4v4h4v-4zM8 10H4v4h4v-4z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Channels',
            path: '/management/platform-management/channels',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6  mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 8.5C3.5 7.94772 3.94772 7.5 4.5 7.5H12.5V9.5H4.5C3.94772 9.5 3.5 9.05228 3.5 8.5V8.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.5 7.5H19.5C20.0523 7.5 20.5 7.94772 20.5 8.5V8.5C20.5 9.05228 20.0523 9.5 19.5 9.5H14.5V7.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 12.5C3.5 11.9477 3.94772 11.5 4.5 11.5H9.5V13.5H4.5C3.94772 13.5 3.5 13.0523 3.5 12.5V12.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5V12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H11.5V11.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 16.5C3.5 15.9477 3.94772 15.5 4.5 15.5H15.5V17.5H4.5C3.94772 17.5 3.5 17.0523 3.5 16.5V16.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 15.5H19.5C20.0523 15.5 20.5 15.9477 20.5 16.5V16.5C20.5 17.0523 20.0523 17.5 19.5 17.5H17.5V15.5Z"/>
            </svg>
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Features',
            path: '/management/platform-management/features',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.005 0c-.194-.002-.372.105-.458.276l-2.197 4.38-4.92.7c-.413.06-.578.56-.278.846l3.805 3.407-.953 4.81c-.07.406.363.715.733.523L22 12.67l4.286 2.273c.37.19.8-.118.732-.522l-.942-4.81 3.77-3.408c.3-.286.136-.787-.278-.846l-4.916-.7-2.2-4.38C22.368.11 22.195.002 22.005 0zM22 1.615l1.863 3.71c.073.148.216.25.38.273l4.168.595-3.227 2.89c-.12.112-.173.276-.145.436l.813 4.08-3.616-1.927c-.147-.076-.322-.076-.47 0l-3.59 1.926.823-4.08c.028-.16-.027-.325-.145-.438l-3.262-2.89 4.166-.594c.165-.023.307-.125.38-.272zM16.5 18c-.822 0-1.5.678-1.5 1.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5zM1.5 3C.678 3 0 3.678 0 4.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5zm0 14c-.822 0-1.5.678-1.5 1.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Functions',
            path: '/management/platform-management/functions',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Entities',
            path: '/management/platform-management/entities',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Libraries',
            path: '/management/platform-management/library',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'RBAC',
            path: '/management/platform-management/rbac',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" 
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
         <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
       </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/dbaas/programs',
        label: 'DBaaS Management',
        isEnabled:true,
        svg:(
          <svg className="h-6 w-6 mr-1"  fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 26.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 20q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-3.36q0 1.6-1.632 2.848t-4.32 1.888-6.048 0.64-6.048-0.64-4.32-1.888-1.632-2.848v3.36zM4 14.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 8q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-1.984q0-1.632-1.6-3.008t-4.384-2.176-6.016-0.832-6.016 0.832-4.384 2.176-1.6 3.008v1.984z"/>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'DBaaS Programs',
            path: '/management/dbaas/programs',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1"  fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path stroke="currentColor" d="M4 26.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 20q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-3.36q0 1.6-1.632 2.848t-4.32 1.888-6.048 0.64-6.048-0.64-4.32-1.888-1.632-2.848v3.36zM4 14.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 8q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-1.984q0-1.632-1.6-3.008t-4.384-2.176-6.016-0.832-6.016 0.832-4.384 2.176-1.6 3.008v1.984z"/>
        </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaaS Subscriptions',
            path: '/management/dbaas/subscriptions',
            isEnabled:true,
            svg:(
              <svg viewBox="0 0 24 24"  className="h-6 w-6 mr-1"  fill="none"  xmlns="http://www.w3.org/2000/svg">
              <path stroke="currentColor" d="M18 2H6v2h12V2zM4 6h16v2H4V6zm-2 4h20v12H2V10zm18 10v-8H4v8h16z"/>
            </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/dbaas/endpoints',
        label: 'InfraStructure Management',
        isEnabled:true,
        svg:(
          <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
          <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
          <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
          <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'POP',
            path: '/management/platform-management/pop',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" 
             xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
      </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Endpoints',
            path: '/management/dbaas/endpoints',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Environments',
            path: '/management/dbaas/environments',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Phases',
            path: '/management/dbaas/phases',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Digital Private Infrastructures',
            path: '/management/dbaas/digital-private-infrastructures',
            isEnabled:true,
            svg:(
               <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Digital Public Infrastructures',
            path: '/management/dbaas/digital-public-infrastructures',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Services',
            path: '/management/dbaas/services',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
        ],
      },
	])
	const fetchLogo =()=>{

		const storeData = {
			logoDark : organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
			return logo.Background === 'Light'
			  }),
			 logoLight:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
				return logo.Background === 'Dark'
				  }),
			 storeName:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
			 description:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
			 favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/img/logo.png'
		  }
		  setLogo(storeData)
	}

const handleNavigate = (data:any) => {
  navigate(`${data}`)
}
  const handleItemClick = (index:any) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleSubItemClick = (index:any) => {
    setActiveSubIndex(index === activeSubIndex ? null : index);
  };
useEffect(() => {
 fetchLogo()
}, [])
useEffect(() => {
	setColor(theme)
	


}, [theme]);


const dispatch = useAppDispatch();

const handleSideBarView = () => {
  dispatch(settings.set({ sidebar: !sidebar }))
}

	return (
	<>
 <div className="sticky top-0 z-[1000]">
        <div className={`w-full h-20 p-5 flex items-center justify-between primary-${color}`}>
          <div className="flex">
            <div className="flex items-center mr-4">
              <div className={`${sidebar ? "ml-8" : ""}`}>
                {sidebar ? <>{logo && logo?.logoDark?.length > 0 && <img src={logo?.logoDark[0]?.Url} className="w-32 h-12 " />}</> : <>{logo && logo?.logoDark?.length > 0 && <img src={logo?.logoDark[0]?.Url} className="w-16 h-8 " />}</>}
              </div>
             
            </div>
          </div>
          <div className="flex items-center ">
            <ol>
              <li className="hoverable flex items-start  ">
                <div className="relative block py-6 px-4 lg:p-6 text-sm  font-bold hover:bg-secondary  hover:text-blue-500">
                  <svg width="24" height="24" className=" text-white" viewBox="0 0 24 24" fill="none">
                    <path stroke="#ffffff" stroke-width="2" d="M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5ZM14 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5ZM4 16a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3ZM14 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6Z" />
                  </svg>
                </div>
				<div className={`mega-menu mt-16 p-2 shadow-xl primary-${color}`}>
                  <div className="container w-full flex flex-wrap justify-start mx-2">
                    {menus.map((menuData: any, index: any) => (
                      <ul className="px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r lg:border-b-0">
                        <div
                          onClick={() => handleItemClick(index)}
                          className="flex items-center justify-start cursor-pointer my-2">
                          {/* <svg className="h-5  mr-3 fill-current text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                          </svg> */}
                          {menuData?.svg}
                          <span className="hover:text-yellow-400 w-36 text-sm" onClick={()=>handleNavigate(menuData?.path)}>{menuData?.label}</span>
                          {activeIndex !== index ? <svg fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                            <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
C255,161.018,253.42,157.202,250.606,154.389z"/>
                          </svg> :
                            <svg fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                              <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                            </svg>}
                        </div>
                        {menuData?.subMenu && activeIndex === index && (
                          <ul className={`flex flex-col items-center justify-start text-sm pl-10 ${activeIndex !== index ? 'hidden' : ''}`}>
                            {menuData?.subMenu.map((subMenuData: any, subMenuindex: any) => (
                              <>
                                <div onClick={() => handleSubItemClick(subMenuindex)} className="flex w-full text-left cursor-pointer my-1">
                                  {/* <svg className="h-5  mr-3 fill-current text-white"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                                  </svg> */}
                                  {subMenuData?.svg}
                                  <h3 className=" text-md text-white px-2" onClick={() => handleNavigate(subMenuData?.path)}>	<a className="text-light hover:text-yellow-400">{subMenuData?.label}</a>
                                  </h3>
                                  {subMenuData?.subMenu ? (activeSubIndex !== subMenuindex ? <svg className="mt-1" fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                                    <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
C255,161.018,253.42,157.202,250.606,154.389z"/>
                                  </svg> :
                                    <svg className="mt-1" fill="#FFFFFF" height="14" width="14" version="1.1" id="Layer_1" viewBox="0 0 330 330">
                                      <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                                    </svg>) : ''}
                                </div>
                                {subMenuData?.subMenu && activeSubIndex === subMenuindex && (
                                  <ul className={`w-full flex-col items-center justify-start text-sm pl-10 ${activeSubIndex !== subMenuindex ? 'hidden' : ''}`}>
                                    {subMenuData?.subMenu.map((functionData: any, functionIndex: any) => (
                                      <>
                                        <div className="flex w-full text-left cursor-pointer my-2">
                                          {/* <svg className="h-5  mr-3 fill-current text-white"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" />
                                          </svg> */}
                                          {functionData?.svg}
                                          <h3 className=" text-md text-black px-2" onClick={() => handleNavigate(functionData?.path)}>
                                            <a className="text-light hover:text-yellow-400" >{functionData?.label}</a>
                                          </h3>
                                        </div>
                                      </>
                                    ))}
                                  </ul>
                                )}
                              </>
                            ))}
                          </ul>
                        )}
                      </ul>
                    ))}
                  </div>
                </div>
              </li>
            </ol>
            <div className="px-3 pl-0">
            {Notification.permission === 'granted' ?
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.04283 5.1757C8.59546 4.75121 9.24946 4.43224 10.0136 4.23441C10.0046 4.15752 10 4.0793 10 4C10 2.89543 10.8955 2 12 2C13.1046 2 14 2.89543 14 4C14 4.0793 13.9954 4.15752 13.9864 4.23441C14.7506 4.43224 15.4046 4.75121 15.9572 5.1757C16.933 5.92519 17.4981 6.93095 17.8325 7.93362C18.1644 8.92891 18.2842 9.96595 18.3426 10.8395C18.3663 11.1941 18.3806 11.5351 18.3932 11.8357L18.4018 12.0385C18.4175 12.3994 18.433 12.6684 18.4596 12.8673C18.6553 14.329 18.8982 15.3543 19.2438 16.1741C19.5816 16.9754 20.0345 17.6202 20.7071 18.2929C20.9931 18.5789 21.0787 19.009 20.9239 19.3827C20.7691 19.7564 20.4045 20 20 20H13.7325C13.9026 20.2942 14 20.6357 14 21C14 22.1046 13.1046 23 12 23C10.8955 23 10 22.1046 10 21C10 20.6357 10.0974 20.2942 10.2676 20H4.00003C3.59557 20 3.23093 19.7564 3.07615 19.3827C2.92137 19.009 3.00692 18.5789 3.29292 18.2929C3.96694 17.6189 4.4186 16.9787 4.75553 16.1809C5.1004 15.3642 5.3434 14.3395 5.54043 12.8673C5.56706 12.6684 5.58255 12.3994 5.59827 12.0385L5.60687 11.8357C5.61945 11.5351 5.63371 11.1941 5.65744 10.8395C5.7159 9.96595 5.83561 8.92891 6.16756 7.93362C6.50196 6.93095 7.06705 5.92519 8.04283 5.1757ZM6.06869 18C6.26568 17.6741 6.44135 17.3298 6.59797 16.959C7.04284 15.9056 7.31562 14.6803 7.52276 13.1327C7.56305 12.8316 7.58113 12.4756 7.59638 12.1255L7.60555 11.9095C7.61808 11.6105 7.63109 11.3002 7.65298 10.973C7.70745 10.159 7.81312 9.32109 8.06482 8.56638C8.31407 7.81905 8.6909 7.19981 9.26113 6.7618C9.82482 6.32883 10.6723 6 12 6C13.3278 6 14.1752 6.32883 14.7389 6.7618C15.3092 7.19981 15.686 7.81905 15.9352 8.56638C16.1869 9.32109 16.2926 10.159 16.3471 10.973C16.369 11.3002 16.382 11.6105 16.3945 11.9095L16.3945 11.9095L16.3945 11.9096L16.4037 12.1255C16.4189 12.4756 16.437 12.8316 16.4773 13.1327C16.6832 14.671 16.956 15.8957 17.4008 16.9509C17.5583 17.3244 17.735 17.6714 17.9334 18H6.06869Z" fill="#ffffff"></path> </g></svg> :
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4C14 4.0793 13.9954 4.15752 13.9864 4.23441C14.6078 4.39529 15.1564 4.63627 15.6368 4.94896L14.1699 6.41585C13.6414 6.16531 12.9414 6 12 6C10.6723 6 9.82479 6.32883 9.2611 6.7618C8.69087 7.19981 8.31404 7.81905 8.06479 8.56638C7.81309 9.32109 7.70742 10.159 7.65295 10.973C7.63106 11.3002 7.61806 11.6104 7.60552 11.9094L7.60552 11.9095V11.9095L7.59635 12.1255C7.58242 12.4452 7.56614 12.7698 7.53273 13.0531L4.96511 15.6207C5.20312 14.9011 5.3859 14.0218 5.5404 12.8673C5.56703 12.6684 5.58253 12.3994 5.59824 12.0385L5.60684 11.8357L5.60684 11.8357L5.60684 11.8357C5.61942 11.5351 5.63369 11.1941 5.65742 10.8395C5.71587 9.96595 5.83559 8.92891 6.16753 7.93362C6.50193 6.93095 7.06702 5.92519 8.0428 5.1757C8.59543 4.75121 9.24943 4.43224 10.0136 4.23441C10.0046 4.15752 10 4.0793 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4ZM12 23C13.1046 23 14 22.1046 14 21C14 20.6357 13.9026 20.2942 13.7324 20H20C20.4045 20 20.7691 19.7564 20.9239 19.3827C21.0787 19.009 20.9931 18.5789 20.7071 18.2929C20.0344 17.6202 19.5816 16.9754 19.2438 16.1741C18.8982 15.3543 18.6552 14.329 18.4596 12.8673C18.433 12.6684 18.4175 12.3994 18.4018 12.0385L18.3932 11.8357C18.3806 11.5351 18.3663 11.1941 18.3426 10.8395C18.3098 10.3503 18.2579 9.80975 18.1602 9.25401L16.3528 11.0614C16.3713 11.3562 16.3831 11.6374 16.3945 11.9094L16.3945 11.9096L16.3945 11.9096L16.4037 12.1255C16.4189 12.4756 16.437 12.8316 16.4773 13.1327C16.6832 14.671 16.956 15.8957 17.4008 16.9509C17.5582 17.3244 17.735 17.6714 17.9333 18H9.41422L7.41422 20H10.2676C10.0974 20.2942 10 20.6357 10 21C10 22.1046 10.8954 23 12 23ZM19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L19.7071 5.70711Z" fill="#ffffff"></path> </g></svg>}
            </div>
            <div className="px-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ffffff" viewBox="0 0 256 256"><path d="M201.89,54.66A103.43,103.43,0,0,0,128.79,24H128A104,104,0,0,0,24,128v56a24,24,0,0,0,24,24H64a24,24,0,0,0,24-24V144a24,24,0,0,0-24-24H40.36A88.12,88.12,0,0,1,190.54,65.93,87.39,87.39,0,0,1,215.65,120H192a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h24a24,24,0,0,1-24,24H136a8,8,0,0,0,0,16h56a40,40,0,0,0,40-40V128A103.41,103.41,0,0,0,201.89,54.66ZM64,136a8,8,0,0,1,8,8v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V136Zm128,56a8,8,0,0,1-8-8V144a8,8,0,0,1,8-8h24v56Z"></path></svg>
            </div>
            <a onClick={() =>handleNavigate('/gateway/profile')}>
              <img src="https://a7sas.net/wp-content/uploads/2019/07/4060.jpeg" className="mx-3 w-12 h-12 rounded-full shadow-lg" />
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
export default Header;